import React from 'react';
import OverheadCraneAddEdit from './overhead-crane-add-edit';
import OverheadCraneAddEditModal from './overhead-crane-add-edit-modal';

import { MODAL_TYPES } from 'Feature/components/app-modals';

const { OVERHEAD_CRANE_ADD_EDIT } = MODAL_TYPES;

const OverheadCraneModals = () => {
  return (
    <>
      <OverheadCraneAddEdit modalId={OVERHEAD_CRANE_ADD_EDIT} />
      <OverheadCraneAddEditModal />
    </>
  );
};

export default OverheadCraneModals;
